module.exports = "<nav class=\"navbar navbar-dark qr-mena-appbar-dark \">\r\n        <div class=\"container\">\r\n        <img alt=\"branding logo\" src=\"/assets/Img/qrmena-images/posmena_logo.png\" class=\"navbar-brand\" style=\"width:70px;height:70px;\">\r\n             <h5 class=\"text-uppercase text-secondary\"></h5>\r\n        <i class=\"fa fa-cutlery text-light fa-2x\" aria-hidden=\"true\"></i>\r\n        </div>\r\n</nav>  "


//////////////////
// WEBPACK FOOTER
// ./src/QrMena/components/header/header.component.html
// module id = ./src/QrMena/components/header/header.component.html
// module chunks = main